
import { Lead } from "@/types/lead";
import { toast } from "@/hooks/use-toast";

export const parseCSVToLeads = (csvContent: string): Partial<Lead>[] => {
  try {
    const lines = csvContent.split('\n');
    if (lines.length < 2) {
      throw new Error('CSV file is empty or missing data rows');
    }
    
    const headers = lines[0].split(',');
    const leads: Partial<Lead>[] = [];
    
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      
      const values: string[] = [];
      let currentValue = '';
      let insideQuotes = false;
      
      for (let j = 0; j < line.length; j++) {
        const char = line[j];
        
        if (char === '"') {
          insideQuotes = !insideQuotes;
        } else if (char === ',' && !insideQuotes) {
          values.push(currentValue);
          currentValue = '';
        } else {
          currentValue += char;
        }
      }
      
      values.push(currentValue);
      
      if (values.length >= headers.length) {
        const lead: Partial<Lead> = {};
        headers.forEach((header, index) => {
          const value = values[index].trim();
          if (value) {
            const field = header.trim().toLowerCase().replace(/\s([a-z])/g, (match, letter) => letter.toUpperCase());
            
            // Convert numeric fields
            if (field === 'latitude' || field === 'longitude' || field === 'rating' || field === 'reviewCount') {
              (lead as any)[field] = isNaN(Number(value)) ? null : Number(value);
            } else {
              (lead as any)[field] = value;
            }
          }
        });
        leads.push(lead);
      }
    }
    
    return leads;
  } catch (error) {
    console.error('Error parsing CSV to leads:', error);
    toast({
      title: "CSV Parsing Failed",
      description: "An error occurred while parsing the CSV file. Please check the file format and try again.",
      variant: "destructive",
    });
    return [];
  }
};
